const Footer = () => {
  return (
    <div className='bg-white fixed bottom-0 left-0 right-0 width-auto flex justify-end p-1'>
      <div className=''>
        <a className='' href='mailto:kate.malaia@gmail.com'>
          kate.malaia@gmail.com
        </a>
      </div>
    </div>
  )
}

export default Footer
